export default "__VITE_ASSET__q_xTqkNX__"